export default __webpack_public_path__ + "static/media/slider-2.21f526e7.jpg";